import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Space,
  Popconfirm,
  Input,
  Modal,
  Select,
  Upload,
  Checkbox,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  UploadOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { toast } from "react-toastify";
import API from "../../../utils/api";

const { Option } = Select;
const BASE_URL = "https://api.smartdeals.rs"; // 🌐 SERVER URL

const ProductsList = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [editProduct, setEditProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [productImages, setProductImages] = useState([]);

  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, []);

  const fetchProducts = async () => {
    try {
      const { data } = await API.get("/products");
      console.log("📦 Učitani proizvodi:", data);
      setProducts(data);
    } catch (error) {
      toast.error("Greška pri učitavanju proizvoda!");
    }
  };

  const fetchCategories = async () => {
    try {
      const { data } = await API.get("/categories");
      setCategories(data);
    } catch (error) {
      toast.error("Greška pri učitavanju kategorija!");
    }
  };

  const handleDelete = async (id) => {
    try {
      await API.delete(`/products/${id}`);
      setProducts(products.filter((item) => item.id !== id));
      toast.success("Proizvod uspešno obrisan!");
    } catch (error) {
      toast.error("Greška pri brisanju proizvoda!");
    }
  };

  const handleEdit = async (product) => {
    setEditProduct(product);
    setIsModalOpen(true);
    fetchProductImages(product.id);
  };

  const fetchProductImages = async (productId) => {
    try {
      const { data } = await API.get(`/products/${productId}/images`);
      console.log("🖼️ Slike za proizvod:", productId, data);
      setProductImages(
        data.map((img) => ({
          ...img,
          image_url: `${BASE_URL}${img.image_url}`, // 🌍 Puni URL
        }))
      );
    } catch (error) {
      toast.error("Greška pri učitavanju slika!");
    }
  };

  const handleUploadImage = async (file, productId) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const { data } = await API.post(
        `/products/${productId}/upload-image`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      setProductImages([...productImages, data]);
      toast.success("Slika uspešno dodata!");
    } catch (error) {
      toast.error("Greška pri upload-u slike!");
    }
  };

  // 🔄 LOGIKA ZA PRIKAZ SLIKE U TABELI
  const getProductImage = (record) => {
    if (!record.images || record.images.length === 0) return "N/A";

    const mainImage = record.images.find((img) => img.is_main === 1);
    const fallbackImage = record.images[0];

    return (
      <img
        src={`${BASE_URL}${
          mainImage ? mainImage.image_url : fallbackImage.image_url
        }`}
        alt="Product"
        width={50}
        style={{ borderRadius: "5px", border: "1px solid #ddd" }}
      />
    );
  };

  const columns = [
    {
      title: "Slika",
      dataIndex: "images",
      key: "images",
      render: (_, record) => getProductImage(record),
    },
    { title: "Naziv", dataIndex: "name", key: "name" },
    { title: "Cena", dataIndex: "price", key: "price" },
    { title: "Kategorija", dataIndex: "category", key: "category" },
    { title: "Stanje na lageru", dataIndex: "stock", key: "stock" },
    {
      title: "Akcije",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          >
            Uredi
          </Button>
          <Popconfirm
            title="Obriši proizvod?"
            onConfirm={() => handleDelete(record.id)}
            okText="Da"
            cancelText="Ne"
          >
            <Button type="danger" icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <h2>Lista proizvoda</h2>
      <Table columns={columns} dataSource={products} rowKey="id" />

      {/* ✅ MODAL ZA IZMENE */}
      <Modal
        title="Uredi proizvod"
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
      >
        {editProduct && (
          <div>
            <h4>Naziv</h4>
            <Input
              value={editProduct.name}
              onChange={(e) =>
                setEditProduct({ ...editProduct, name: e.target.value })
              }
            />

            <h4>Kategorija</h4>
            <Select
              style={{ width: "100%" }}
              value={editProduct.category}
              onChange={(value) =>
                setEditProduct({ ...editProduct, category: value })
              }
            >
              {categories.map((cat) => (
                <Option key={cat.id} value={cat.name}>
                  {cat.name}
                </Option>
              ))}
            </Select>

            <h4>Slike proizvoda</h4>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {productImages.map((img, index) => (
                <img
                  key={index}
                  src={img.image_url}
                  alt="Product"
                  width={70}
                  style={{ borderRadius: "5px", border: "1px solid #ddd" }}
                />
              ))}
            </div>

            <Upload
              customRequest={({ file }) =>
                handleUploadImage(file, editProduct.id)
              }
              showUploadList={false}
            >
              <Button icon={<UploadOutlined />}>Dodaj slike</Button>
            </Upload>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ProductsList;
